import * as Yup from 'yup';

export const validationSchema = Yup.object().shape<any>({
  code: Yup.string()
    .required('Please enter the verification code.')
    .min(6, ({ min }) => `The verification has to have ${min} digits.`)
    .max(6, ({ max }) => `The verification has to have ${max} digits.`)
    .matches(/^\d+$/, 'The verfication code can only consist of digits.'),
});
